module.exports = __webpack_public_path__ + "icons/original/small/small-b3.65f5bcb765e8dc6f37ec5174e112cea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-b3.png
// module id = RUP8
// module chunks = app